<template>
  <!-- 风能利用-中学组 -->
  <div class="IntelligentUniversityGroup">

    <el-form
      ref="ruleForm"
      :model="ruleForm"
      label-width="180px"
      :label-position="lablePosition"
      :rules="rules"
    >

      <el-form-item
        label="作品名称"
        prop="worksName"
        :rules="[{ required: true, message: '请输入作品名称',trigger: 'change'}]"
      >
        <el-input v-model="ruleForm.worksName" placeholder="作品名称" :disabled="submitted"></el-input>
      </el-form-item>


      <el-form-item
        label="作品简介"
        prop="brief"
        :rules="[{ required: true, message: '请输入作品简介',trigger: 'change'},{ max: 500, message: '长度不能超过500',trigger: 'change'}]"
      >
        <el-input type="textarea" v-model="ruleForm.brief" placeholder="500字以内" :disabled="submitted"></el-input>
      </el-form-item>

      <el-form-item label="比赛成绩" prop="mind" :rules="[{ required: true}]" >
        <el-input v-model="ruleForm.mind" placeholder="___秒___毫秒" :disabled="submitted"></el-input>
      </el-form-item>
      <!-- :rules="[{ required: true}]" -->
      <el-form-item label="材料照片" prop="materialPhotos" >
        <el-upload
          class="upload-demo"
          :action="storageURL + '/MaterialPhotos/' + ruleForm.remark"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="materialPhotosList"
          :on-success="handleSuccess"
          :before-upload="beforeMaterialPhotosUpload"
          list-type="picture"
          :disabled="submitted"
        >
          <el-button size="small" type="primary" :disabled="submitted">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">图片尺寸不低于1024*768px，格式为JPG，大小50M以内</div>
        </el-upload>
      </el-form-item>
      <!-- :rules="[{ required: true}]" -->
      <el-form-item label="作品照片" prop="worksPhoto" >
        <el-upload
          class="upload-demo"
          :action="storageURL + '/WorksPhoto/' + ruleForm.remark"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="worksPhotoList"
          :on-success="handleSuccess"
          :before-upload="beforeMaterialPhotosUpload"
          list-type="picture"
          :disabled="submitted"
        >
          <el-button size="small" type="primary" :disabled="submitted">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">图片尺寸不低于1024*768px，格式为JPG，大小50M以内</div>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="比赛视频" prop="competitionVideo">
        <el-upload
          class="upload-demo"
          :action="storageURL + '/CompetitionVideo/' + ruleForm.remark"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="competitionVideoList"
          :on-success="handleSuccess"
          list-type="picture"
          :disabled="submitted"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">时长不超过3分钟，大小200M以内</div>
        </el-upload>
      </el-form-item>-->
      <!-- :rules="[{ required: true}]" -->
      <el-form-item label="比赛视频" prop="logo" >
        <fileComponent
          ref="fileComponent"
          @getMd5="getHash"
          :uploadType="['avi','mov','flv','mp4']"
          v-if="fileFalg"
          msg="5分钟以内，格式为MP4、AVI、MOV或FLV，大小200M以内"
          maxSize="209715200"
          :remark="ruleForm.remark"
          :submitted="submitted"
        ></fileComponent>
      </el-form-item>
      <el-form-item label="其他文件" prop="otherFiles">
        <el-upload
          class="upload-demo"
          :action="storageURL + '/OtherFiles/' + ruleForm.remark"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="otherFilesList"
          :on-success="handleSuccess"
          list-type="picture"
          :disabled="submitted"
        >
          <el-button size="small" type="primary" :disabled="submitted">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-row :gutter="20" style="text-align: center;margin: 20px 0 50px 0;" v-if="!submitted">
      <el-col :span="24" style="text-align: center;">
        <el-checkbox v-model="checked">我已阅读且同意</el-checkbox>
        <span style="font-size: 14px;color: #1a78fc;cursor: pointer;" @click="viewRule">《参赛须知》</span>
      </el-col>
      <el-col :offset="8" :span="4" style="text-align: center;">
        <el-button
          @click="saveContParticipant"
          style="background:#1a78fc;color:#fff;width:100px;"
        >保存</el-button>
      </el-col>
      <el-col :span="4" style="text-align: center;">
        <el-button
          @click="submitContParticipant"
          style="background:#f17421;color:#fff;width:100px;"
        >提交</el-button>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="ruleVisible" width="50%">
      <span>大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则大赛规则</span>
    </el-dialog>
  </div>
</template>

<script>
import fileComponent from "@/components/fileComponent";
import { getFileList, deleteFile } from "@/api/system/index";

export default {
  props: ["selectData"],
  components: {
    fileComponent,
  },
  data() {
    return {
      fileFalg: false,
      checked: false,
      ruleForm: {
        remark: "",
      },
      rules: {
        worksName: [
          { required: true, message: "请输入作品名称", trigger: "blur" },
        ],
        brief: [{ required: true, message: "请输入作品简介", trigger: "blur" }],
        mind: [{ required: true, message: "请输入比赛成绩", trigger: "blur" }],
        // materialPhotos: [
        //   { required: true, message: "请上传", trigger: "blur" }
        // ],
        // worksPhoto: [{ required: true, message: "请上传", trigger: "blur" }],
        // competitionVideo: [
        //   { required: true, message: "请上传", trigger: "blur" }
        // ],
        // otherFiles: [{ required: true, message: "请上传", trigger: "blur" }]
      },
      materialPhotosList: [],
      materialPhotos:0,
      worksPhotoList: [],
      worksPhoto:0,
      competitionVideoList: [],
      otherFilesList: [],
      ruleVisible: false,
      submitted: false,
      lablePosition: "right",
      hashAry: [],
    };
  },
  beforeMount() {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (mobile) {
      this.lablePosition = "top";
    }
  },
  created() {
    this.ruleForm = this.selectData;
    if (this.ruleForm.status == 1) {
      this.submitted = true;
    }
    if (this.ruleForm.remark) {
      this.fileFalg = true;
    }
    this.getList();
    console.log("子类中的ruleForm", this.ruleForm);
  },
  watch: {
    selectData: function (newFlag, oldFlag) {
      console.log("科普展品 ----- newFlag", newFlag);
      console.log("科普展品 ----- oldFlag", oldFlag);
      this.ruleForm = newFlag;
      if (this.ruleForm.status == 1) {
        this.submitted = true;
      }
      this.getList();
    },
    deep: true,
  },
  methods: {
    // 删除文件
    handleRemove(file, fileList) {
      deleteFile(this.systemURL, file.uid);
      if (file.response.data.businessCode == "MaterialPhotos") {
        this.materialPhotos--;
      } else if (file.response.data.businessCode == "WorksPhoto") {
        this.worksPhoto--;
      }
    },
    handlePreview(file) {},
    handleSuccess(response, file, fileList) {
      file.uid = response.data.id;
      if (response.data.businessCode == "MaterialPhotos") {
        this.materialPhotos++;
      } else if (response.data.businessCode == "WorksPhoto") {
        this.worksPhoto++;
      }
    },
    beforeMaterialPhotosUpload(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (["jpg"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为jpg的附件！",
        });
        return false;
      }
      this.isLt2k = file.size / 1024 / 1024 < 100 ? "1" : "0";
      if (this.isLt2k === "0") {
        this.$message({
          message: "上传文件大小不能超过50M!",
          type: "error",
        });
      }
      return this.isLt2k === "1" ? true : false;
    },
    beforeWorksPhotoUpload(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (
        ["MP4", "AVI", "MOV", "FLV", "mp4", "avi", "mov", "flv"].indexOf(
          FileExt.toLowerCase()
        ) === -1
      ) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为MP4、AVI、MOV、FLV的附件！",
        });
        return false;
      }
      this.isLt2k = file.size / 1024 / 1024 < 200 ? "1" : "0";
      if (this.isLt2k === "0") {
        this.$message({
          message: "上传文件大小不能超过200M!",
          type: "error",
        });
      }
      return this.isLt2k === "1" ? true : false;
    },
    getHash(value, name, length) {
      this.hashAry.push({
        hash: value,
        fileName: name,
      });
      if (this.hashAry.length == length) {
        this.submitFalg = true;
      }
    },
    saveContParticipant() {
      this.ruleForm.status = "0";
      if (!this.checked) {
        this.$message("请阅读并同意《原创声明》");
        return;
      }
      var api = this.baseURL + "/actuator/works/addAndEditFile";
      var params = {
        form: this.ruleForm,
      };
      this.axios
        .post(api, params)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$router.push({
              path: "/myHome",
              query: { articleId: "2" },
            });
            this.$router.go(0);
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch((error) => {
          this.$message({
            message: "系统异常",
            type: "error",
          });
        });
    },
    submitContParticipant() {
      this.ruleForm.status = "1";
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message("请阅读并同意《原创声明》");
            return;
          }else if(this.materialPhotos==0){
            this.$message("请上传材料照片")
            return;
          }else if(this.worksPhoto==0){
            this.$message("请上传作品照片")
            return;
          }else if (this.$refs.fileComponent.completeArray.length==0) {
            this.$message("请上传演示视频");
            return;
          }
          var api = this.baseURL + "/actuator/works/addAndEditFile";
          var params = {
            form: this.ruleForm,
          };
          this.axios
            .post(api, params)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$router.push({
                  path: "/myHome",
                  query: { articleId: "2" },
                });
                this.$router.go(0);
              } else {
                this.$message(res.data.msg);
              }
            })
            .catch((error) => {
              this.$message({
                message: "系统异常",
                type: "error",
              });
            });
        }
      });
    },
    getList() {
      // 获取文件信息
      if (this.ruleForm.remark) {
        getFileList(this.systemURL, this.ruleForm.remark).then((res) => {
          for (let i = 0; i < res.data.completeArray.length; i++) {
            if (res.data.completeArray[i].businessCode == "MaterialPhotos") {
              this.materialPhotosList.push({
                name: res.data.completeArray[i].fileName,
                url: res.data.completeArray[i].path,
                uid: res.data.completeArray[i].id,
                response: {data:res.data.completeArray[i]}
              });
              this.materialPhotos++;
            } else if (res.data.completeArray[i].businessCode == "WorksPhoto") {
              this.worksPhotoList.push({
                name: res.data.completeArray[i].fileName,
                url: res.data.completeArray[i].path,
                uid: res.data.completeArray[i].id,
                response: {data:res.data.completeArray[i]}
              });
              this.worksPhoto++;
            } else if (
              res.data.completeArray[i].businessCode == "CompetitionVideo"
            ) {
              this.competitionVideoList.push({
                name: res.data.completeArray[i].fileName,
                url: res.data.completeArray[i].path,
                uid: res.data.completeArray[i].id,
              });
            } else if (res.data.completeArray[i].businessCode == "OtherFiles") {
              this.otherFilesList.push({
                name: res.data.completeArray[i].fileName,
                url: res.data.completeArray[i].path,
                uid: res.data.completeArray[i].id,
              });
            }
          }
        });
      }
    },
    viewRule() {
      this.ruleVisible = true;
    },
  },
};
</script>


<style scoped>
.worksDeclare .el-form-item__content .upload-demo {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/worksDeclare/WindEnergyMiddleSchoolGroup.vue